'use strict';

var REACT_BASE_PATH = window.location.port === '3001'
  ? 'http://localhost:3000'
  : '/v2/web/index.html';
var REACT_QA_QUEUE_PATH = '/queues/qa';

var ReactNavigationService = /*@ngInject*/ function($state, $location) {
  this.goToJobDetail = function(jobId) {
    window.open(`${REACT_BASE_PATH}#/job/${jobId}`, '_blank');
  };

  this.goToQAQueue = function() {
    const source = $location.search().source;
    const tab = $location.search().tab;

    if (source === 'react') {
      var reactUrl = `${REACT_BASE_PATH}#${REACT_QA_QUEUE_PATH}`;
      if (tab) {
        reactUrl += `?tab=${tab}`;
      }
      window.open(reactUrl, '_self');
      return;
    }

    $state.go('queue.qa');
  };
};

module.exports = ReactNavigationService;
